var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.7,
    height: 18.7,
    viewBox: "0 0 18.7 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add-circle",
    "data-name": "Icon ionic-ios-add-circle",
    d: "M12.725,3.375a9.35,9.35,0,1,0,9.35,9.35A9.349,9.349,0,0,0,12.725,3.375Zm4.068,10.069H13.444v3.349a.719.719,0,0,1-1.438,0V13.444H8.657a.719.719,0,0,1,0-1.438h3.349V8.657a.719.719,0,0,1,1.438,0v3.349h3.349a.719.719,0,0,1,0,1.438Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/add-circle-icon.5af0543a47eb9c407142fede54f5e2a0.svg";
export { ForwardRef as ReactComponent };